import React from 'react'
import { useIntl } from 'react-intl'
import CtaGroup from './CtaGroup'
import { NewActivityCreationCta } from '@/app/models/new-activity-creation-state'

export const CtaGroupWrapper = (props: any) => {
    const { ctaConfig, componentClass, ctaHandler } = props

    const intl = useIntl()

    return (
        <>
            <div
                className={`${componentClass}__footer-left smart-modals-cta-group__footer-left-container`}>
                <CtaGroup
                    ctaList={ctaConfig.left.filter((item: NewActivityCreationCta) => item.show())}
                    onCta={ctaHandler}
                    mode="link"
                    outlined
                    groupedText={intl.formatMessage({
                        id: 'modals.news_execution.button.options',
                        defaultMessage: 'Options',
                    })}
                />
            </div>
            <div className={`${componentClass}__footer-right`}>
                <CtaGroup
                    ctaList={ctaConfig.right.filter((item: NewActivityCreationCta) => item.show())}
                    onCta={ctaHandler}
                    mode="button"
                    groupedText={intl.formatMessage({
                        id: 'modals.news_execution.button.actions',
                        defaultMessage: 'Actions',
                    })}
                />
            </div>
        </>
    )
}
